import { Component, OnInit, NO_ERRORS_SCHEMA, ViewEncapsulation, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  schemas: [NO_ERRORS_SCHEMA]
})
export class FooterComponent implements OnInit {
  @Input() bg: boolean = false;
  appName = environment.title;
  currentYear = new Date().getFullYear();
  privacyPolicyUrl = environment.privacyPolicyUrl;

  ngOnInit(): void {}

}
